import {Row} from 'antd';
import classes from '../Pages.module.css';
import NormDataField from './NormDataField'

const BasicLeaveDetails = (props) => {

    const handleChange = (e,param) => {

        props.setData(data => {
            const newdata = [...data['header']['rows']]
            newdata[0][param] = e.target.value
            return({
                ...data,
                header : {
                    ...data.header,
                    rows: newdata
                }
            })
        })
    }

    const handleDChange = (date, dateString, param) => {

        props.setData(data => {
            const newdata = [...data['header']['rows']]
            newdata[0][param] = dateString
            return({
                ...data,
                header : {
                    ...data.header,
                    rows: newdata
                }
            })
        })
    }

    const handleSChange = (val,param) => {

        props.setData(data => {
            const newdata = [...data['header']['rows']]
            newdata[0][param] = val
            return({
                ...data,
                header : {
                    ...data.header,
                    rows: newdata
                }
            })
        })
    }

    return(
        <div>
        <p></p>
        <Row className={props.editMode ? classes["RowDEX"] : classes["RowD"]}>
          <NormDataField
            editMode={props.editMode}
            lg={4}
            md={24}
            handleChange={handleSChange}
            options={props.ad.EMP_CODE}
            type="Select"
            name="Employee Name"
            param="emp_code"
            value={props.data.emp_code ? props.data.emp_code : null}
          />
          {!props.create && (
            <NormDataField
              editMode={props.editMode}
              lg={4}
              md={24}
              handleChange={handleChange}
              name="Norms Code"
              param="norms_hdr_code"
              value={props.data.norms_hdr_code ? props.data.norms_hdr_code : null}
            />
          )}
          <NormDataField
            editMode={props.editMode}
            lg={4}
            md={24}
            handleChange={handleSChange}
            options={props.ad.EMP_TYPE}
            type="Select"
            name="Employee Type"
            param="emp_type"
            value={props.data.emp_type ? props.data.emp_type : null}
          />
          <NormDataField
            editMode={props.editMode}
            lg={4}
            md={24}
            handleChange={handleChange}
            name="Age"
            param="age"
            value={props.data.age ? props.data.age : null}
          />
          <NormDataField
            editMode={props.editMode}
            lg={4}
            md={24}
            handleChange={handleSChange}
            options={props.ad.GENDER}
            type="Select"
            name="Gender"
            param="gender"
            value={props.data.gender ? props.data.gender : null}
          />
          <NormDataField
            editMode={props.editMode}
            lg={4}
            md={24}
            handleChange={handleSChange}
            options={props.ad.DEPARTMENT_CODE}
            type="Select"
            name="Department"
            param="department_code"
            value={props.data.department_code ? props.data.department_code : null}
          />
          <NormDataField
            editMode={props.editMode}
            lg={4}
            md={24}
            handleChange={handleSChange}
            options={props.ad.DESIGNATION_CODE}
            type="Select"
            name="Designation"
            param="designation_code"
            value={props.data.designation_code ? props.data.designation_code : null}
          />
          {/* <NormDataField
            editMode={props.editMode}
            lg={12}
            md={24}
            handleChange={handleSChange}
            options={props.ad.UNIT_CODE}
            type="Select"
            name="SITE"
            param="unit_code"
            value={props.data.unit_code ? props.data.unit_code : null}
          /> */}
        </Row>
        <p></p>
        <Row className={props.editMode ? classes["RowDEX"] : classes["RowD"]}>
          <NormDataField
            editMode={props.editMode}
            lg={4}
            md={24}
            handleChange={handleChange}
            name="Associated Company"
            param="associated_comp"
            value={props.data.associated_comp ? props.data.associated_comp : null}
          />
          <NormDataField
            editMode={props.editMode}
            lg={4}
            md={24}
            handleChange={handleChange}
            name="Associated Company TO"
            param="associated_comp_to"
            value={props.data.associated_comp_to ? props.data.associated_comp_to : null}
          />
          <NormDataField
            editMode={props.editMode}
            lg={4}
            md={24}
            handleChange={handleDChange}
            type="Date"
            name="From Date"
            param="from_date"
            value={props.data.from_date ? props.data.from_date : null}
            required="True"

          />
          <NormDataField
            editMode={props.editMode}
            lg={4}
            md={24}
            handleChange={handleDChange}
            type="Date"
            name="To Date"
            param="to_date"
            value={props.data.to_date ? props.data.to_date : null}
            required="True"
          />
          
          <NormDataField
            editMode={props.editMode}
            lg={4}
            md={24}
            handleChange={handleChange}
            name="Dist. From Native Place"
            param="distancefrom"
            value={props.data.distancefrom ? props.data.distancefrom : null}
          />
          <NormDataField
            editMode={props.editMode}
            lg={4}
            md={24}
            handleChange={handleChange}
            name="Dist. To Native Place"
            param="distanceto"
            value={props.data.distanceto ? props.data.distanceto : null}
          />
        </Row>
        <p></p>
      </div>
      
    );
}

export default BasicLeaveDetails